import { put } from 'redux-saga/effects';
import schedulesSlice from '../slice';

const { success } = schedulesSlice.actions;

export default function* successResponder({ normalized, meta }) {
  yield put(success({ target: meta.target, schedules: normalized.entities.schedules }));
}
